
/* FURMORIES 2026 - interactions. Vanilla, no dependencies. */
(function(){
  'use strict';
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- scroll reveal ---------- */
  function reveal(root){
    var els = (root||document).querySelectorAll('.fm-rv:not(.is-in), .fm-mask:not(.is-in)');
    if(!els.length) return;
    if(RM || !('IntersectionObserver' in window)){
      Array.prototype.forEach.call(els,function(e){e.classList.add('is-in');});
      return;
    }
    var io = new IntersectionObserver(function(ents){
      ents.forEach(function(en){
        if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    },{rootMargin:'0px 0px -8% 0px',threshold:0.08});
    Array.prototype.forEach.call(els,function(e){io.observe(e);});
  }

  /* ---------- header ---------- */
  function header(root){
    var hd = (root||document).querySelector('[data-fm-header]');
    if(!hd || hd.__fmInit) return; hd.__fmInit = 1;
    var menu = document.getElementById(hd.getAttribute('data-menu-id'));
    var burger = hd.querySelector('[data-fm-burger]');
    function onScroll(){ hd.classList.toggle('is-stuck', window.scrollY > 8); }
    window.addEventListener('scroll', onScroll, {passive:true}); onScroll();
    if(burger && menu){
      burger.addEventListener('click', function(){
        var open = hd.classList.toggle('is-open');
        menu.classList.toggle('is-open', open);
        burger.setAttribute('aria-expanded', open ? 'true':'false');
        document.documentElement.style.overflow = open ? 'hidden' : '';
      });
      Array.prototype.forEach.call(menu.querySelectorAll('a'),function(a){
        a.addEventListener('click',function(){
          hd.classList.remove('is-open'); menu.classList.remove('is-open');
          document.documentElement.style.overflow='';
        });
      });
    }
  }

  /* ---------- hero slideshow ---------- */
  function hero(root){
    Array.prototype.forEach.call((root||document).querySelectorAll('[data-fm-hero]'),function(el){
      if(el.__fmInit) return; el.__fmInit = 1;
      var slides = el.querySelectorAll('[data-fm-slide]');
      var dots = el.querySelectorAll('[data-fm-dot]');
      var idx = el.querySelector('[data-fm-idx]');
      var tot = el.querySelector('[data-fm-tot]');
      if(!slides.length) return;
      var i = 0, timer = null;
      var delay = parseInt(el.getAttribute('data-interval')||'6000',10);
      if(tot) tot.textContent = ('0'+slides.length).slice(-2);
      function go(n){
        i = (n + slides.length) % slides.length;
        Array.prototype.forEach.call(slides,function(s,k){
          s.classList.toggle('is-on', k===i);
          var v = s.querySelector('video');
          if(v){ if(k===i){ var p=v.play(); if(p&&p.catch)p.catch(function(){}); } else { try{v.pause();}catch(e){} } }
        });
        Array.prototype.forEach.call(dots,function(d,k){ d.classList.toggle('is-on', k===i); });
        if(idx) idx.textContent = ('0'+(i+1)).slice(-2);
      }
      function start(){ if(RM || slides.length<2) return; stop(); timer = setInterval(function(){go(i+1);}, delay); }
      function stop(){ if(timer){clearInterval(timer); timer=null;} }
      Array.prototype.forEach.call(dots,function(d,k){ d.addEventListener('click',function(){ go(k); start(); }); });
      el.addEventListener('mouseenter', stop); el.addEventListener('mouseleave', start);
      go(0); start();
    });
  }

  /* ---------- video modal ---------- */
  function vmodal(root){
    Array.prototype.forEach.call((root||document).querySelectorAll('[data-fm-vopen]'),function(btn){
      if(btn.__fmInit) return; btn.__fmInit=1;
      btn.addEventListener('click',function(){
        var m = document.getElementById(btn.getAttribute('data-fm-vopen'));
        if(!m) return;
        m.classList.add('is-open');
        document.documentElement.style.overflow='hidden';
        var v = m.querySelector('video'); if(v){ v.currentTime=0; var p=v.play(); if(p&&p.catch)p.catch(function(){}); }
      });
    });
    Array.prototype.forEach.call((root||document).querySelectorAll('[data-fm-vclose]'),function(x){
      if(x.__fmInit) return; x.__fmInit=1;
      x.addEventListener('click',function(e){
        if(e.target !== x) return;
        var m = x.closest('.fm-vmodal') || x;
        m.classList.remove('is-open');
        document.documentElement.style.overflow='';
        var v = m.querySelector('video'); if(v){ try{v.pause();}catch(err){} }
      });
    });
    document.addEventListener('keydown',function(e){
      if(e.key!=='Escape') return;
      Array.prototype.forEach.call(document.querySelectorAll('.fm-vmodal.is-open'),function(m){
        m.classList.remove('is-open'); document.documentElement.style.overflow='';
        var v=m.querySelector('video'); if(v){try{v.pause();}catch(err){}}
      });
    });
  }

  /* ---------- carousel (testimonials / generic) ---------- */
  function carousel(root){
    Array.prototype.forEach.call((root||document).querySelectorAll('[data-fm-car]'),function(el){
      if(el.__fmInit) return; el.__fmInit=1;
      var track = el.querySelector('[data-fm-track]');
      var cells = track ? track.children : [];
      var prev = el.querySelector('[data-fm-prev]');
      var next = el.querySelector('[data-fm-next]');
      if(!track || !cells.length) return;
      var i = 0;
      function per(){
        if(window.innerWidth >= 1100) return 3;
        if(window.innerWidth >= 760) return 2;
        return 1;
      }
      function max(){ return Math.max(0, cells.length - per()); }
      function apply(){
        if(i > max()) i = max();
        var c = cells[0];
        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
        var step = c.getBoundingClientRect().width + gap;
        track.style.transform = 'translate3d(' + (-i*step) + 'px,0,0)';
        if(prev) prev.disabled = (i<=0);
        if(next) next.disabled = (i>=max());
      }
      if(prev) prev.addEventListener('click',function(){ i=Math.max(0,i-1); apply(); });
      if(next) next.addEventListener('click',function(){ i=Math.min(max(),i+1); apply(); });
      var t; window.addEventListener('resize',function(){ clearTimeout(t); t=setTimeout(apply,140); });
      // touch swipe
      var x0=null;
      track.addEventListener('touchstart',function(e){ x0=e.touches[0].clientX; },{passive:true});
      track.addEventListener('touchend',function(e){
        if(x0===null) return;
        var dx = e.changedTouches[0].clientX - x0; x0=null;
        if(Math.abs(dx) < 40) return;
        i = dx < 0 ? Math.min(max(), i+1) : Math.max(0, i-1);
        apply();
      },{passive:true});
      apply();
    });
  }

  /* ---------- product variants ---------- */
  function product(root){
    Array.prototype.forEach.call((root||document).querySelectorAll('[data-fm-product]'),function(el){
      if(el.__fmInit) return; el.__fmInit=1;
      var dataEl = el.querySelector('[data-fm-variants]');
      if(!dataEl) return;
      var variants = [];
      try{ variants = JSON.parse(dataEl.textContent); }catch(e){ return; }
      var quoteOnly = el.hasAttribute('data-fm-quote');
      var idField = el.querySelector('[data-fm-varid]');
      var priceEl = el.querySelector('[data-fm-price]');
      var btn = el.querySelector('[data-fm-atc]');
      var inputs = el.querySelectorAll('[data-fm-opt]');
      function selected(){
        var vals = [];
        Array.prototype.forEach.call(inputs,function(inp){
          if(inp.checked) vals[parseInt(inp.getAttribute('data-fm-opt'),10)] = inp.value;
        });
        return vals;
      }
      function update(){
        var vals = selected();
        var match = null;
        for(var k=0;k<variants.length;k++){
          var v = variants[k], ok = true;
          for(var o=0;o<vals.length;o++){ if(vals[o] && v.options[o] !== vals[o]){ ok=false; break; } }
          if(ok){ match = v; break; }
        }
        if(!match) return;
        if(idField) idField.value = match.id;
        if(priceEl && !quoteOnly) priceEl.innerHTML = match.priceHtml;
        if(btn && !quoteOnly){
          btn.disabled = !match.available;
          var lbl = btn.querySelector('.fm-btn__lbl') || btn;
          lbl.textContent = match.available ? btn.getAttribute('data-label-add') : btn.getAttribute('data-label-sold');
        }
        if(match.imageIndex > -1){
          var fig = el.querySelectorAll('[data-fm-fig]')[match.imageIndex];
          if(fig && fig.scrollIntoView && !RM) fig.scrollIntoView({behavior:'smooth',block:'center'});
        }
        try{
          var u = new URL(window.location.href); u.searchParams.set('variant', String(match.id).replace(/\D/g,''));
          window.history.replaceState({}, '', u.toString());
        }catch(e){}
      }
      Array.prototype.forEach.call(inputs,function(inp){ inp.addEventListener('change', update); });
      update();
    });
  }

  function initAll(root){ reveal(root); header(root); hero(root); vmodal(root); carousel(root); product(root); }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(document); });
  } else { initAll(document); }

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
  document.addEventListener('shopify:section:select', function(e){ initAll(e.target); });
  window.FurmoriesInit = initAll;
})();


/* Kids Bunk Bed project video: skip black fade-in / fade-out frames (2026-09-23) */
(function(){function f(v){if(v.dataset.fmTrim)return;v.dataset.fmTrim=1;v.removeAttribute('poster');v.preload='auto';var s=1.8,e=30.2;function go(){if(v.currentTime<s)v.currentTime=s}v.addEventListener('loadedmetadata',go);v.addEventListener('play',go);v.addEventListener('timeupdate',function(){if(v.currentTime>=e||v.currentTime<s-0.5)v.currentTime=s});if(v.readyState>=1)go()}function run(){document.querySelectorAll('video[src*="79974a04f11f434d80a7aab5acd51843"]').forEach(f)}if(document.readyState!='loading')run();else document.addEventListener('DOMContentLoaded',run)})();
